export { default as MainPage } from './MainPage';
export { default as CompanyPage } from './CompanyPage';
export { default as BusinessPage } from './BusinessPage';
export { default as PerformancePage } from './PerformancePage';
export { default as DirectionsPage } from './DirectionsPage';